<template>
    <div class="adminProductTextEdit">
        <br>
        <div>
            <input class="prodName" v-model="nameName">
            <textarea v-model="descDesc"></textarea>
            <input :class="['imageLink', !imageValid.status ? 'linkError' : '']" v-model="imageLink">
            <p class="statusMsg errorMsg" v-if="!imageValid.status"><i class="fa fa-exclamation-circle"></i> <span v-html="imageValid.message"></span></p>
            <p class="statusMsg valid" v-if="imageValid.status"><i class="fa fa-check-circle"></i> {{imageValid.message}}</p>
            <p class="imageQualityCheck" v-if="!imageValid.qualityValidation.status"><label><input v-if="!imageValid.qualityValidation.status" type="checkbox" v-model="imageValid.qualityValidation.forceBadQuality"> {{imageValid.qualityValidation.message}}</label></p>
            <button :disabled="!validateDataBeforeSave" class="btn save" @click="saveProductData">Save</button>
            <button class="cancel btn" @click="$emit('updateProduct', {type: 'cancel', val: true})">cancel</button>
        </div>
    </div>
</template>

<script>
    export default {
        props: ["edit", "desc", "contentID", "productName", "productData", "imgUrl"],
        data() {
            return {
                imageValid: {
                    status: false,
                    message: '',
                    qualityValidation: {
                        status: false,
                        forceBadQuality: false,
                        message: "I know my image is bad quality and I don't care",
                        min_width: 250,
                    }
                },
            }
        },
        methods: {
            getMetaData: function(url) {
                var _that = this;
                var img = new Image();
                img.onerror = function() {
                    _that.imageValid.status = false;
                    _that.imageValid.message = 'Image could not be found. Try another URL'
                    _that.imageValid.qualityValidation.status = true;
                }
                img.onload = function() {
                    if (img.complete) {
                        if (this.width >= _that.imageValid.qualityValidation.min_width) {
                            _that.imageValid.status = true;
                            _that.imageValid.qualityValidation.status = true;
                            _that.imageValid.message = 'Valid image'
                        } else {
                            _that.imageValid.status = false;
                            _that.imageValid.message = 'Image have to be at least <b>'+_that.imageValid.qualityValidation.min_width+'px</b> wide. This image is <b>'+this.width+'px</b>'
                            _that.imageValid.qualityValidation.status = false;
                        }
                    }
                }
                img.src = url;
            },
            saveProductData: function(obj) {
            
                var payload = new Object();
                payload["WCMS_WebPageContent_ID"] = this.productData.WCMS_WebPageContent_ID;
                payload["LongDescription"] = this.descDesc;
                payload["Name"] = this.nameName;
                payload["ImageUrl"] = this.imageLink;
                axios.post(basedir + '/ajaxRequestServlet?mode=WebContentElement', JSON.stringify([payload]), {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }).then(response => {
                    this.$emit("updateProductWithNewData", {
                        description: this.descDesc,
                        name: this.nameName,
                        image: this.imageLink
                    })
                })
            },
        },
        computed: {
            validateDataBeforeSave: function() {
                return (this.nameName != '' && (this.imageValid.status || (this.imageValid.message.includes('Image have to be at least') && this.imageValid.qualityValidation.forceBadQuality)))
            },
            descDesc: {
                get: function() {
                    var txt = document.createElement("textarea");
                    txt.innerHTML = this.desc.trim();
                    return txt.value;
                },
                set: function(newValue) {
                    this.$emit("updateProduct", {
                        type: 'setDesc',
                        val: newValue.trim()
                    })
                }
            },
            nameName: {
                get: function() {
                    return this.productName;
                },
                set: function(newValue) {
                    this.$emit("updateProduct", {
                        type: 'setName',
                        val: newValue
                    })
                }
            },
            imageLink: {
                get: function() {
                    
                    var saveImageUrl;
                    if (typeof this.imgUrl != 'undefined') {
                        // const url = this.imgUrl;
                        // const imageID = url.match(/\/ID(\d+)/);
                       // saveImageUrl = imageID ? `ID${imageID[1]}.th3.png` : this.imgUrl;
                       saveImageUrl =  this.imgUrl;
                       this.getMetaData(this.imgUrl)
                    }
                    return saveImageUrl;
                },
                set: function(newValue) {
                    this.getMetaData(newValue)
                    this.$emit("updateProduct", {
                        type: 'setImage',
                        val: newValue
                    })
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .btn {
        background: white;
        font-size: 1em;
        border-radius: 4px;
        cursor: pointer;
        font-weight: bold;
        text-transform: uppercase;
        margin-left: 5px;
        margin-right: 5px;
        transition: all 0.2s ease-in-out;
        i {
            font-size: 0.8em;
            transition: all 0.2s ease-in-out;
            padding-right: 5px;
            color: #004570;
        }
    }
    .edit {
        border: 2px solid #004570;
        color: #004570;
        float: right;
        &:hover {
            background: #004570;
        }
    }
    .adminProductTextEdit {
        .statusMsg {
            span {
                 font-size: 0.8em;
                 b {
                    font-size: 1em;
                 }
            }
           
            i {
                font-size: 1.2em;
            }
        }
        .errorMsg {
            span {
            color: #e88282 !important;
            }
                b {
                    color: #e88282;
                }
            i {
                color: #af6363;
            }
        }
        .valid {
            
            font-size: 0.8em;
            color: #7caf63;
            i {
                color: #7caf63;
            }
        }
        .imageQualityCheck {
            padding: 5px;
            border: 1px solid #ad5a5a;
            background: #f2e1e1;
            label {
                cursor: pointer;
                color: #ad5a5a;
            }
        }
        .prodName,
        .imageLink {
            font-size: 1em;
            font-family: monospace;
            background: #ebf0f4;
            color: #121212;
            border-radius: 6px;
            border: 2px solid #004570;
            box-shadow: 2px 2px 20px 0px #dddddd;
            width: 94%;
            padding: 7px;
            margin-bottom: 9px;
        }
        .linkError {
            border-color: #e88282;
        }
        textarea {
            font-size: 1em;
            font-family: monospace;
            background: #ebf0f4;
            color: #121212;
            border-radius: 6px;
            border: 2px solid #004570;
            box-shadow: 2px 2px 20px 0px #dddddd;
        }
        .btn.save {
            border: 2px solid #7caf63;
            color: #7caf63;
            &:hover {
                color: white;
                background: #7caf63;
                &:disabled {
                    background: white;
                    color: #cfcfcf;
                }
            }
            &:disabled {
                border-color: #cfcfcf;
                color: #cfcfcf;
            }
        }
        .btn.cancel {
            border: 2px solid #e88282;
            color: #e88282;
            &:hover {
                color: white;
                background: #e88282;
            }
        }
    }
</style>

<style>
.errorMsg span b {
    font-size: 1em;
    color: #e88282;
}
</style>